/*
 * Toont onder de grote productfoto alleen de foto's van de gekozen kleur.
 * Foto's die bij geen enkele kleur horen (algemene/detailfoto's) blijven altijd staan.
 *
 * Werkt samen met km-image-swatches: leest de kleur->foto-id kaart en
 * verbergt/toont de media-items + thumbnails bij een kleurwissel.
 */
(function () {
  function init(root) {
    const mapEl = (root || document).querySelector('.km-color-media-map');
    if (!mapEl) return;
    const sectionId = mapEl.dataset.section;
    let colorMedia;
    try {
      colorMedia = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }

    // Alle foto-id's die aan íéts een kleur gekoppeld zijn.
    const allColorIds = new Set();
    Object.values(colorMedia).forEach((ids) => ids.forEach((id) => allColorIds.add(id)));

    const gallery = document.querySelector('.product__media-wrapper, media-gallery');
    if (!gallery) return;

    function idOf(el) {
      return el.getAttribute('data-media-id') || (el.dataset ? el.dataset.target : null);
    }

    function apply(color) {
      const wanted = new Set(colorMedia[color] || []);

      // Media-items (grote weergave) en thumbnails
      const items = gallery.querySelectorAll('[data-media-id], .thumbnail-list__item[data-target]');
      items.forEach((el) => {
        const id = idOf(el);
        if (!id) return;
        const isColorImage = allColorIds.has(id);
        // Toon: gedeelde foto's (geen kleur) altijd; kleurfoto's alleen als ze bij deze kleur horen.
        // Vangnet: de foto die het thema als actief heeft staan, nooit verbergen.
        const isActive = el.classList.contains('is-active');
        const show = !isColorImage || wanted.has(id) || isActive;
        el.classList.toggle('km-media-hidden', !show);
      });
    }

    function selectedColor() {
      const checked = document.querySelector('.km-image-swatches__input:checked');
      return checked ? checked.value : Object.keys(colorMedia)[0];
    }

    // Bij welke kleur hoort de foto die het thema nú als actief heeft gezet?
    // Dat is de betrouwbaarste bron bij het openen van de pagina: kom je binnen met
    // een kleur in het webadres (?variant=...), dan werkt het thema de aangevinkte
    // kleurknop pas even later bij. Las je die te vroeg uit, dan filterde dit script
    // op de verkeerde kleur en verdween juist de grote foto.
    function colorOfActiveMedia() {
      const active = gallery.querySelector('.product__media-item.is-active');
      if (!active) return null;
      const id = idOf(active);
      if (!id) return null;
      const found = Object.keys(colorMedia).find((color) => (colorMedia[color] || []).indexOf(id) !== -1);
      return found || null;
    }

    function currentColor() {
      return colorOfActiveMedia() || selectedColor();
    }

    // Bij een kleurwissel opnieuw filteren.
    document.querySelectorAll('.km-image-swatches__input').forEach((input) => {
      input.addEventListener('change', () => {
        // Kleine vertraging: Dawn werkt eerst zijn eigen media bij.
        setTimeout(() => apply(selectedColor()), 60);
      });
    });

    apply(currentColor());
    // Nog een keer nadat het thema klaar is met zijn eigen bijwerken.
    setTimeout(() => apply(currentColor()), 400);
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
